const ABViewCore = require("../../core/views/ABViewCore");
module.exports = class ABView extends ABViewCore {};
